<template>
  <div class="row p-list-representation-wrapper align-items-start w-100">
        <div class="row w-100 p-list-representation-province-main pr-4 pl-4">

          <div class="w-100 d-flex flex-wrap p-list-representation-province-data-item mt-4 mb-4">
              <div class="row p-salon-map-item ml-3 align-items-center">
                  <h3 class="p-salon-map-item-title">نام سالن:</h3>
                  <h3 class="p-salon-map-item-title mr-1">سالن شماره یک تست</h3>
              </div>
              <div class="row p-salon-map-item ml-3 align-items-center">
                  <h3 class="p-salon-map-item-title">نام صاحب سالن:</h3>
                  <h3 class="p-salon-map-item-title  mr-1">سید محمد معافی</h3>
              </div>
          </div>

          <div class=" d-flex flex-wrap p-map-salon-data w-100">
            <mapSalon :form-data="formData" @changeLocation="changeLocation"></mapSalon>

            <button @click="submitData" type="button" class="mt-4 btn btn-primary btn-blue btn-sm btn-table "> ثبت/ویرایش</button>
          </div>

        </div>

  </div>
</template>

<script>
import mapSalon from './mapSalon';



export default {
  name: "mapLocation",
  components: {
    mapSalon,
  },

  props: {
    formData   : {type:Object,default:{}},
  },

  data() {
    return {
      mapLocation : {},
    }
  },

  watch: {


  },

  created() {

  },

  mounted() {

  },

  methods: {
    submitData(){
      this.$emit('submitData',this.mapLocation);
    },

    changeLocation(data){
      this.mapLocation = data;
    },

  }


}
</script>
